import React from "react";
import { Mail, Phone, MapPin, Facebook, Linkedin, Instagram } from "lucide-react";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="container-custom py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div className="space-y-4">
            <div className="flex items-center space-x-3">
              <img
                src="/quality-logo.png"
                alt="ISO 9001:2015"
                className="h-12 w-auto object-contain"
              />
              <div>
                <p className="text-lg font-semibold text-white">ISO 9001:2015 Certified</p>
                <p className="text-sm text-gray-300">Quality Assured Since 2000</p>
              </div>
            </div>
            <p className="text-lg font-semibold bg-gradient-to-r from-red-300 via-pink-300 to-rose-300 bg-clip-text text-transparent italic">
              "Adding colors to life"
            </p>
            <p className="text-sm leading-relaxed">
              Leading manufacturer of UV & LED curable coatings for the printing industry since 2000.
            </p>
            <div className="flex space-x-4">
              <a
                href="https://www.instagram.com/crimson_inks_/"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-gray-800 p-2 rounded-lg hover:bg-[#8B1538] transition-colors"
              >
                <Instagram className="h-5 w-5" />
              </a>
              <a
                href="#"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-gray-800 p-2 rounded-lg hover:bg-[#8B1538] transition-colors"
              >
                <Facebook className="h-5 w-5" />
              </a>
              <a
                href="#"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-gray-800 p-2 rounded-lg hover:bg-[#8B1538] transition-colors"
              >
                <Linkedin className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-bold text-lg mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => scrollToSection('hero')}
                  className="hover:text-white transition-colors"
                >
                  Home
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('about')}
                  className="hover:text-white transition-colors"
                >
                  About Us
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('coatings')}
                  className="hover:text-white transition-colors"
                >
                  UV/LED Solutions
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('products')}
                  className="hover:text-white transition-colors"
                >
                  Products
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="hover:text-white transition-colors"
                >
                  Contact
                </button>
              </li>
            </ul>
          </div>

          {/* Products */}
          <div>
            <h3 className="text-white font-bold text-lg mb-4">Products</h3>
            <ul className="space-y-2 text-sm">
              <li>UV/LED Curable Coatings</li>
              <li>Security UV/LED Coatings</li>
              <li>Gravure Inks</li>
              <li>Flexo Inks</li>
              <li>Water-Based Emulsions</li>
              <li>Specialty Coatings</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-bold text-lg mb-4">Contact</h3>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start space-x-2">
                <MapPin className="h-5 w-5 text-[#8B1538] flex-shrink-0 mt-0.5" />
                <span>
                  G-12, 13, Bajrang Bali Audyogic Asthan, Raniganj, Site-4 Panki, Kanpur, UP
                </span>
              </li>
              <li className="flex items-center space-x-2">
                <Phone className="h-5 w-5 text-[#8B1538]" />
                <span>+91 7706994400</span>
              </li>
              <li className="flex items-center space-x-2">
                <Mail className="h-5 w-5 text-[#8B1538]" />
                <span>Crimson.inks7475@gmail.com</span>
              </li>
              <li className="flex items-center space-x-2">
                <Mail className="h-5 w-5 text-[#8B1538]" />
                <span>Crimsoninks.knp@gmail.com</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-800">
        <div className="container-custom py-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0 text-sm">
            <p>
              © {currentYear} Crimson Inks Private Limited. All rights reserved.
            </p>
            <div className="flex space-x-6">
              <span>ISO 9001:2015 Certified</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
